//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('UserSettings', function ($resource, CONTAINER_API_URL) {
            return $resource(CONTAINER_API_URL + 'webapi/usersettings/:extensionKey/:settingKey');
        })
        .factory('UserProfileSettings', function ($resource, CONTAINER_API_URL) {
            return $resource(CONTAINER_API_URL + 'webapi/usersettings/profile/:extensionKey/:settingKey');
        })
        .factory('userSettingsService', userSettingsService);


    function userSettingsService($q, UserSettings, UserProfileSettings) {

        var service = {};

        service.user = {
            gid: 'the_user'
        };

        service.saveUserProfile = function (extensionKey, settingKey, settingValue) {

            var stringifiedSettingValue = JSON.stringify(settingValue);

            return UserProfileSettings.save({
                extensionKey: extensionKey,
                settingKey: settingKey
            }, stringifiedSettingValue, function () {

                console.log('UserProfile saved.');
            });
        };

        service.saveUserSetting = function (extensionKey, settingKey, settingValue) {

            var stringifiedSettingValue = JSON.stringify(settingValue);
            
            var d = $q.defer();

            var userSetting =  UserSettings.save({
                extensionKey: extensionKey,
                settingKey: settingKey
            },
            stringifiedSettingValue,
            function () {
                d.resolve(userSetting.settingValue ? JSON.parse(userSetting.settingValue) : null);
            }, function (error) {
                d.reject(error);
            });

            return d.promise;
        };

        service.loadUserSetting = function (extensionKey, settingKey) {

            var d = $q.defer();

            var userSetting = UserSettings.get(
                {
                    'extensionKey': extensionKey,
                    'settingKey': settingKey

                }, function () {

                    d.resolve(userSetting.settingValue ? JSON.parse(userSetting.settingValue) : null);

                }, function (error) {

                    d.reject(error);
                });
            return d.promise;
        };

        service.removeUserSetting = function (extensionKey, settingKey) {

            return UserSettings.delete(
                {
                    'extensionKey': extensionKey,
                    'settingKey': settingKey

                }, function (result) {
                    console.log(result);
                });
        };
        
        return service;

    }


})();